module.exports = __webpack_public_path__ + "img/tile-onionskins_cn.1c1d6b0.jpg";